import { render, staticRenderFns } from "./SwiperNav.vue?vue&type=template&id=bd9c5570&scoped=true&"
import script from "./SwiperNav.vue?vue&type=script&lang=js&"
export * from "./SwiperNav.vue?vue&type=script&lang=js&"
import style0 from "./SwiperNav.vue?vue&type=style&index=0&id=bd9c5570&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd9c5570",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIconDownArrow: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/svg/IconDownArrow.vue').default})
